import React from 'react';
import PropTypes from 'prop-types';

import IOGrid from './IOGrid';

export default function IOSaida({ data, onCallback, idposto }) {
  return (
    <IOGrid
      data={data}
      onCallback={onCallback}
      tipoIO="S"
      title="IO de Saída"
      idposto={idposto}
    />
  );
}

IOSaida.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  onCallback: PropTypes.func.isRequired,
  idposto: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IOSaida.defaultProps = {
  data: [],
  idposto: null,
};
